import React, { Component } from 'react';
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import './helpers/configure-axios';

import './App.css';
// Styles
// Import React Bootstrap Table Styles
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
// CoreUI Icons Set
import '@coreui/icons/css/coreui-icons.min.css';
// Import Flag Icons Set
import 'flag-icon-css/css/flag-icon.min.css';
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application
import './scss/style.css'

import { DefaultLayout, Login, Page404, Page500, Registration, ForgotPassword, ResetPassword } from './containers';

// import { renderRoutes } from 'react-router-config';

class App extends Component {
  render() {
    const props = this.props;
    const PublicRoute = ({ component: Component, ...rest }) => (
      <Route {...rest} render={(routeProps) => (
        !props.user
          ? <Component {...routeProps} />
          : <Redirect to='/' />
      )} />
    );
    const PrivateRoute = ({ component: Component, ...rest }) => (
      <Route {...rest} render={(routeProps) => (
        props.user
          ? <Component {...routeProps} />
          : <Redirect to='/login' />
      )} />
    );

    return (
      <HashRouter>
        <Switch>
          <PublicRoute exact path="/login" name="Login Page" component={Login} />
          <PublicRoute exact path="/register" name="Registration Page" component={Registration} />
          <PublicRoute exact path="/forgot-password" name="Forgot Password" component={ForgotPassword} />
          <PublicRoute exact path="/reset-password" name="Forgot Password" component={ResetPassword} />
          <Route exact path="/404" name="Page 404" component={Page404} />
          <Route exact path="/500" name="Page 500" component={Page500} />
          <PrivateRoute path="/" name="Home" component={DefaultLayout} />
        </Switch>
      </HashRouter>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.user,
});

export default connect(
  mapStateToProps,
  null
)(App);



// WEBPACK FOOTER //
// ./src/App.js